import { Controller } from "@hotwired/stimulus"

// Vult het doel in uren in op basis van het gekozen vastentype (bijv. "16:8 (16 uur)").
export default class extends Controller {
  updateHours() {
    const match = this.element.selectedOptions[0]?.text.match(/\((\d+) uur\)/)
    const input = this.element.form?.querySelector("[name='fasting_session[target_hours]']")
    if (match && input) input.value = match[1]
  }
}
